import * as React from 'react';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';

import { User } from 'types/User';
import { SHOW_UPGRADE_BUTTON } from 'layouts/AppPageTemplate/utils/config';
import { Routes } from 'constants/pages';

interface Props {
  user: User | null;
}

export const UpgradeButton: React.FC<Props> = (props) => {
  const { user } = props;

  const navigate = useNavigate();
  const onUpgradeClick = () => {
    navigate(Routes.Plans);
  };

  if (user && SHOW_UPGRADE_BUTTON.includes(user.pack)) {
    return (
      <Button
        variant="contained"
        color="secondary"
        onClick={onUpgradeClick}
        style={{
          letterSpacing: 'normal',
        }}
      >
        <h4 className="font-bold">Upgrade your plan</h4>
      </Button>
    );
  }

  return null;
};
UpgradeButton.displayName = 'DesktopNav.UpgradeButton';
